import { Card } from '@nextui-org/react';
import React from 'react';
import Typography from './common/Typography';
import Button from './common/Button';
import CheckIcon from '@mui/icons-material/Check';
import theme from '../theme';

interface IPlanCard {
  planName: string;
  planDescription: string;
  style?: React.CSSProperties;
  price: string;
  onClick: () => void;
  perks: string[];
}

export default function PlanCard({
  planDescription,
  planName,
  perks,
  onClick,
  price,
  style
}: IPlanCard) {
  return (
    <Card 
      className='p-6'
      style={style}>
      <Typography 
        className='text-center'
        style={{fontWeight: 600}}
        variant='headline3'>
          {planName}
      </Typography>
      <Typography
        className='text-center my-4' 
        variant='display'>
          {planDescription}
      </Typography>
      <div className='flex flex-col gap-6'>
        {
          perks.map((perk, idx) => (
            <div className='flex gap-3' key={idx}>
              <CheckIcon style={{color: theme.color.primary}} />
              <Typography 
                colorVariant='primary'
                variant='display'>
                  {perk}
              </Typography>
            </div>
          ))
        }
      </div>
      <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', marginTop: theme.sizing.x3}}>
        <Typography
          variant='headline3'
          className='text-center mb-3'>
          {price}
        </Typography>
      </div>
      <Button 
        className='mt-auto'
        title='SELEZIONA'
        onClick={onClick}/>
    </Card>
  )
}